import React from 'react';
import { useTranslation } from 'react-i18next';

import MediaTypography from 'components/MediaTypography';
import { LanguageTranslationKeys } from 'i18n/languages/en';

import { AboutPageSectionType } from '@common/modules/Report/types';

import {
	StyledReportAboutItemImage,
	StyledReportAboutItemLink,
	StyledReportAboutItemWrap,
} from './styled';

function ReportAboutItem({
	title,
	areaName,
	href,
	imageSrc,
	isPrimary,
}: AboutPageSectionType<LanguageTranslationKeys>) {
	const { t } = useTranslation();
	return (
		<StyledReportAboutItemLink to={href} sx={{ gridArea: { sm: areaName } }}>
			<StyledReportAboutItemWrap sx={{ position: 'relative' }}>
				<StyledReportAboutItemImage alt={title} src={imageSrc} />
				<MediaTypography variants={{ sm: 'h4' }} variant={isPrimary ? 'h2' : 'h4'}>
					{t(title)}
				</MediaTypography>
			</StyledReportAboutItemWrap>
		</StyledReportAboutItemLink>
	);
}

export default ReportAboutItem;
